
import { Component, Vue, Prop } from 'vue-property-decorator'

import { getMerchantStoreList } from "@/api/store";

import {
    debounce
} from "lodash"
@Component
export default class GetMerchantByRemote extends Vue {
    merchantSelectLoading = false;
    allMerchantList = [];
    
    getMerchantRemote = debounce(function (str) {
        this.merchantSelectLoading = true;
        getMerchantStoreList({name: str,pageNum: 1,pageSize: 500}).then((res) => {
          this.merchantSelectLoading = false;
          this.allMerchantList = res.data;
        }).catch((err) => {}).finally(() => {
            this.merchantSelectLoading = false;
        });
    })

    getMerchantList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getMerchantRemote(str)
      }
}







